{
  "Billing": "Fatturazione",
  "Return to App": "Torna all'app",
  "Home": "Home",
  "Calendar": "Calendario",
  "Dashboard": "Dashboard",
  "ATP": "ATP",
  "Subscriptions": "Abbonamenti",
  "Payment Methods": "Metodi di pagamento",
  "Purchases": "Acquisti",
  "View Profile": "Visualizza profilo",
  "TrainingPeaks Athlete Since": "Atleta TrainingPeaks dal",
  "TrainingPeaks Coach Since": "Coach TrainingPeaks dal",
  "Invoice": "Fattura",
  "No results": "Nessun risultato",
  "qtr": "trim.",
  "Show all transactions": "Mostra tutte le transazioni",
  "No transactions found": "Nessuna transazione trovata",
  "Loading purchases": "Caricamento acquisti",
  "Error loading purchases": "Errore nel caricamento degli acquisti",
  "Active": "Attivo",
  "Inactive": "Inattivo",
  "Cancelled": "Annullato",
  "PastDue": "Scaduto",
  "Trialing": "In prova",
  "Next Renewal": "Prossimo rinnovo",
  "Manage": "Gestisci",
  "plus tax": "più imposte",
  "No subscriptions found": "Nessun abbonamento trovato",
  "No purchases found": "Nessun acquisto trovato",
  "Show all": "Mostra tutto",
  "Show less": "Mostra meno",
  "Date": "Data",
  "Description": "Descrizione",
  "Amount": "Importo",
  "Status": "Stato",
  "Paid": "Pagato",
  "Failed": "Non riuscito",
  "Pending": "In attesa",
  "Refunded": "Rimborsato",
  "Loading": "Caricamento",
  "Error loading data": "Errore nel caricamento dei dati",
  "month": "mese",
  "year": "anno",
  "quarter": "trimestre",
  "mo": "mese",
  "yr": "anno",
  "Default": "Predefinito",
  "Expires": "Scade",
  "Card ending in": "Carta che termina con",
  "Flexible planning to fit your life": "Pianificazione flessibile per la tua vita",
  "Actionable Insights to keep you on track": "Informazioni utili per tenerti in carreggiata",
  "Strength training to avoid injury": "Allenamento della forza per evitare infortuni",
  "Ride the world inside on Virtual": "Pedala nel mondo al chiuso con Virtual",
  "Any sport, any device, any time": "Qualsiasi sport, dispositivo e momento",
  "Annual": "Annuale",
  "Monthly": "Mensile",
  "Billed USD $134.99/yr": "Fatturati 134,99 USD/anno",
  "Most Popular": "Più popolare",
  "$19.95 $11.25/mo": "19,95 $ 11,25 $/mese",
  "$19.95/mo": "19,95 $/mese",
  "Checkout": "Pagamento",
  "Progress starts with Premium.": "Il progresso inizia con Premium.",
  "Add Card": "Aggiungi carta",
  "Close": "Chiudi",
  "Primary": "Principale",
  "Delete": "Elimina",
  "Make Primary": "Imposta come principale",
  "Error loading payment methods": "Errore nel caricamento dei metodi di pagamento",
  "Your card has expired. Please add a new card.": "La tua carta è scaduta. Aggiungi una nuova carta.",
  "Unable to load payment form. Please try again later.": "Impossibile caricare il modulo di pagamento. Riprova più tardi.",
  "A temporary $1.00 charge will be made to validate your payment method. This charge is automatically refunded.": "Verrà addebitato temporaneamente 1,00 $ per convalidare il metodo di pagamento. L'importo verrà rimborsato automaticamente.",
  "Payment method added successfully": "Metodo di pagamento aggiunto correttamente",
  "Default payment method updated": "Metodo di pagamento predefinito aggiornato",
  "Payment method deleted": "Metodo di pagamento eliminato",
  "Failed to set default payment method": "Impossibile impostare il metodo di pagamento predefinito",
  "Failed to update default payment method": "Impossibile aggiornare il metodo di pagamento predefinito",
  "Failed to delete payment method": "Impossibile eliminare il metodo di pagamento",
  "Maximize Your Premium Subscription \n Before You Go!": "Sfrutta al massimo il tuo abbonamento Premium\nprima di andare!",
  "TrainingPeaks Virtual": "TrainingPeaks Virtual",
  "Ride inside with our virtual cycling experience": "Pedala al chiuso con la nostra esperienza di ciclismo virtuale",
  "Strength Builder": "Creatore di allenamenti di forza",
  "Create and save strength workouts": "Crea e salva allenamenti di forza",
  "Metrics Charts": "Grafici delle metriche",
  "Analyze metrics from your synced devices": "Analizza le metriche dei tuoi dispositivi sincronizzati",
  "Performance Metrics": "Metriche delle prestazioni",
  "Fitness (CTL), Fatigue (ATL) and Form (TSB)": "Forma fisica (CTL), affaticamento (ATL) e forma (TSB)",
  "Peak Performances": "Prestazioni migliori",
  "Track and compare your best efforts": "Monitora e confronta i tuoi migliori sforzi",
  "NEW!": "NOVITÀ!",
  "Cancel Subscription": "Annulla abbonamento",
  "Renew Subscription": "Rinnova abbonamento",
  "Complimentary": "Gratuito",
  "Your complimentary access is active through": "Il tuo accesso gratuito è attivo fino al",
  "Keep your goals in sight -- renew Premium to stay on track for race day.": "Tieni a mente i tuoi obiettivi: rinnova Premium per restare in carreggiata fino al giorno della gara.",
  "Renew": "Rinnova",
  "Auto-Renew Off": "Rinnovo automatico disattivato",
  "Access through": "Accesso fino al",
  "Turn Auto-Renew On": "Attiva il rinnovo automatico",
  "Are you sure you want to cancel coaching?": "Vuoi davvero annullare il coaching?",
  "Reaching your goals takes the right fit. Before you cancel, let us know if you need to pause, adjust your package level, or speak directly with a Coach Match Specialist.": "Raggiungere i tuoi obiettivi richiede il supporto giusto. Prima di annullare, facci sapere se hai bisogno di mettere in pausa, modificare il livello del tuo pacchetto o parlare direttamente con uno specialista Coach Match.",
  "Pause, Adjust, or Contact Support": "Metti in pausa, modifica o contatta l'assistenza",
  "Yes, Cancel": "Sì, annulla",
  "Keep My Coaching": "Mantieni il mio coaching",
  "Coach Match subscription: Pause, Adjust, or Speak with Specialist": "Abbonamento Coach Match: Metti in pausa, modifica o parla con uno specialista",
  "Hi Coach Match Team,\n\nI am reaching out regarding my coaching membership. Before deciding whether to cancel, I would like to [pause my membership / adjust my package level / speak with a Coach Match Specialist].\n\nMy account email is: [Your Email]\n\nThanks!": "Ciao team Coach Match,\n\nVi contatto riguardo al mio abbonamento di coaching. Prima di decidere se annullare, vorrei [mettere in pausa il mio abbonamento / modificare il livello del mio pacchetto / parlare con uno specialista Coach Match].\n\nIl mio indirizzo e-mail dell'account è: [La tua e-mail]\n\nGrazie!",
  "Before you go...": "Prima di andare...",
  "What's the reason for canceling?": "Qual è il motivo della cancellazione?",
  "Price / Financial Reasons": "Prezzo / Motivi finanziari",
  "The subscription cost no longer fits my budget.": "Il costo dell'abbonamento non rientra più nel mio budget.",
  "Injured / Health Reasons": "Infortunio / Motivi di salute",
  "I'm unable to train due to injury or health.": "Non riesco ad allenarmi a causa di un infortunio o della salute.",
  "Finished Goal Event": "Evento obiettivo completato",
  "I completed my target race or event.": "Ho completato la mia gara o evento obiettivo.",
  "Poor Experience / Fit": "Esperienza negativa / Non adatto",
  "The coaching style or program wasn't the right match.": "Lo stile di coaching o il programma non era quello giusto.",
  "Temporary Pause / Restart Later": "Pausa temporanea / Riprendere più tardi",
  "Life got busy — I'd like to come back when I'm ready.": "La vita è diventata frenetica — vorrei tornare quando sarò pronto/a.",
  "Other": "Altro",
  "Optional: Why?": "Facoltativo: Perché?",
  "Continue": "Continua",
  "Keep Subscription": "Mantieni abbonamento"
}
